module.exports = __webpack_public_path__ + "img/call-center@2x.d551a5a3.png";